import { __rest } from "tslib";
import * as React from 'react';
import { forwardRef } from 'react';
import { domain as localDomain } from '../domain.js';
const defaultAltText = '';
export const ApprovalHandoffBWOnColor = forwardRef((_a, ref) => {
    var { width, domainOverride, alt = defaultAltText, style: userStyle } = _a, props = __rest(_a, ["width", "domainOverride", "alt", "style"]);
    const style = Object.assign(Object.assign({}, userStyle), { width, height: width ? 'auto' : undefined });
    return (React.createElement("img", Object.assign({}, props, { width: width, height: width ? 'auto' : undefined, src: `https://sf-assets.${domainOverride !== null && domainOverride !== void 0 ? domainOverride : localDomain}/illustrations/ApprovalHandoffBWOnColor.svg`, alt: alt, ref: ref, style: style })));
});
//# sourceMappingURL=ApprovalHandoffBWOnColor.js.map